import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';

export interface Contact {
  _id: string;
  contactMail: string;
  associatedStudentID: string;
  status: string;
  followupDate: string;
  followupDateList?: string[];
}

interface ApiListResponse {
  status: string;
  results: number;
  data: { documents: Contact[] };
}

interface ApiDocumentResponse {
  status: string;
  data: { document: Contact };
}

interface ApiCreateResponse {
  status: string;
  data: { contact: Contact };
}

@Injectable({
  providedIn: 'root',
})
export class ContactService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiUrl}/contact`;

  getContacts(): Observable<ApiListResponse> {
    return this.http.get<ApiListResponse>(`${this.baseUrl}/`);
  }

  getAllContacts(): Observable<Contact[]> {
    return this.getContacts().pipe(map((res) => res.data.documents));
  }

  getContactById(id: string): Observable<Contact> {
    return this.http
      .get<ApiDocumentResponse>(`${this.baseUrl}/${id}`)
      .pipe(map((res) => res.data.document));
  }

  createContact(contact: Partial<Contact>): Observable<Contact> {
    return this.http
      .post<ApiCreateResponse>(`${this.baseUrl}/`, contact)
      .pipe(map((res) => res.data.contact));
  }

  updateContact(id: string, contact: Partial<Contact>): Observable<Contact> {
    return this.http
      .patch<ApiDocumentResponse>(`${this.baseUrl}/${id}`, contact)
      .pipe(map((res) => res.data.document));
  }
}
